module.exports = __webpack_public_path__ + "img/solution27.12581561.png";